

import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Purpose extends EntityDto implements IEntityDto {
  Purpose_Id: string;
  PurposeName: string;
  PurposeDescription: string;
  PurposeOrder: number;
  PurposeCode: string;
  Symbol: string;

  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;

  constructor() {
    super();
    this.Purpose_Id = '00000000-0000-0000-0000-000000000000';
    this.PurposeDescription = '';
    this.PurposeName = '';
    this.PurposeOrder = 0;
    this.PurposeCode = '';
    this.Symbol = '';

    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [

      { FieldName: 'PurposeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Name is required' },
      { FieldName: 'PurposeCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      // { FieldName: 'PurposeOrder', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Order is required' },
      // { FieldName: 'PurposeDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Description is required' },

    ];
  }
}